// extracted by mini-css-extract-plugin
module.exports = {"xs":"0","s":"374px","sm":"576px","md":"768px","lg":"992px","xl":"1200px","xxl":"1500px"};